<template>
  <div>
    <div class="pc_all GenerateManagement LogoFile">
      <div class="GenerateManagementContent">
        <div class="GenerateManagementContent_nav">
          <div class="GenerateManagementContent_nav_left">
            <div class="nav_left_dd font20">商务名片</div>
            <div class="nav_left_dt font14">
              全部原创设计，线上/线下全渠道，皆可商用。支持下载JPG、PNG和SVG源文件等格式
            </div>
          </div>
          <div class="GenerateManagementContent_nav_share">
            分享<img alt="" src="@a/ailogo/images/sv14.svg"/>
          </div>
        </div>
        <div class="GenerateManagementContent_txt BusinessCard">
          <div class="GenerateManagementContent_txt_scroll OScroll">
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="svg1Front" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 283">
                    <image id="image_svg1Front" x="15" y="60" width="150" :height="calculateHeight('image_svg1Front')"
                           preserveAspectRatio="xMidYMid meet"
                           :xlink:href="croppedImage"/>
                    <!-- 红色三角形部分 -->
                    <polygon :style="{ fill: cardBackground }" points="0 20 34.1 20 14 0 0 0 0 20"/>
                    <polygon :style="{ fill: cardBackground }" points="33 0 69.8 0 89.9 20.2 53.3 20.2 33 0"/>
                    <polygon :style="{ fill: cardBackground }" points="88.6 0 125.4 0 145.5 20.2 108.9 20.2 88.6 0"/>
                    <polygon :style="{ fill: cardBackground }" points="153.8 0 173.9 20.2 480 20.2 480 0 153.8 0"/>
                    <polygon :style="{ fill: cardBackground }" points="326.2 283 306.1 262.8 0 262.8 0 283 326.2 283"/>
                    <polygon :style="{ fill: cardBackground }" points="480 263 445.9 263 466 283 480 283 480 263"/>
                    <polygon :style="{ fill: cardBackground }"
                             points="447 283 410.2 283 390.1 262.8 426.7 262.8 447 283"/>
                    <polygon :style="{ fill: cardBackground }"
                             points="391.4 283 354.6 283 334.5 262.8 371.1 262.8 391.4 283"/>

                    <!-- 文字部分 -->
                    <text x="260.8" y="66.9" font-family="AlibabaPuHuiTi-Medium, Alibaba PuHuiTi" font-size="26"
                          font-weight="500">张三
                    </text>
                    <text x="260.8" y="94.1" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      职位头衔
                    </text>
                    <text x="260.8" y="136.3" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">188
                      6666 8888
                    </text>
                    <text x="260.8" y="155.5" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      ZhangSan@AiLogo.com
                    </text>
                    <text x="260.8" y="210.3" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      AILOGO科技有限公司
                    </text>
                    <text x="260.8" y="233.2" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      国泰民安万事顺利小区66弄
                    </text>
                    <text x="30.1" y="233.2" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      Ailogo.com
                    </text>
                  </svg>
                </div>
                <div class="list_top_li">
                  <svg id="svg1Back" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 283">
                    <rect style="fill: #f5f5f5" width="480" height="283"/>
                    <image id="image_svg1Back" x="130" y="55" width="180" :height="calculateHeight('image_svg1Back')" preserveAspectRatio="xMidYMid meet"
                           :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">商务名片板式一</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon">
                  <div class="title_icon_title font16"><img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载</div>
                  <div class="title_icon_down">
                    <div class="icon_down_list font14" @click="downloadZIP('svg1Front','svg1Back')"><img alt=""
                                                                                                         src="@a/ailogo/img2/png.svg"/>PNG高清文件下载
                    </div>

                    <div>
                      <!-- isSVG 为 false 时显示完整内容 -->
                      <div v-if="!isSVG" class="icon_down_list font14 svg">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                        <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="down_list_dd">
                          先在创作记录转矢量版
                          <img alt="" src="@a/ailogo/images/sv7on.svg"/>
                        </router-link>
                      </div>
                      <!-- isSVG 为 true 时显示简化内容 -->
                      <div v-else class="icon_down_list font14"
                           @click="downloadZIP('svg1Front','svg1Back',true)">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="svg2Front" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 283">

                    <!-- 背景矩形 -->
                    <rect fill="#fff" x="0" width="480" height="283"/>
                    <image id="image_svg2Front" x="260" y="35" width="135" height="106":height="calculateHeight('image_svg2Front')"  preserveAspectRatio="xMidYMid meet"
                           :xlink:href="croppedImage"/>

                    <!-- 灰色多边形 -->
                    <polygon fill="#c4c4c4"
                             points="0 266 285.9 266 338.9 214.3 480 214.3 480 217 339.9 217 286.2 268.6 0 268.6 0 266"/>

                    <!-- 浅灰色路径 -->
                    <path fill="#e2e2e2"
                          d="M480,225.4l-55.9-54.4c-2.8-3.3-10-3.3-12.8,0l-113.7,112h39.9l74.5-73.4c2.8-3.3,10-3.3,12.8,0l55.2,53.7v-38Z"/>

                    <!-- 橙色路径 -->
                    <path :style="{ fill: cardBackground }"
                          d="M365.7,263l19.8,20.1h54.2l-20.7-21c-4.6-3.9-4.6-13.7,0-17.7l61-62.6v-53.8l-114.3,117.4c-4.6,3.9-4.6,13.7,0,17.7Z"/>

                    <!-- 底部橙色多边形 -->
                    <polygon :style="{ fill: cardBackground }"
                             points="0 280 0 283 331.1 283 327.2 279.1 0 279.1 0 280"/>

                    <!-- 文字部分 -->
                    <text x="30.5" y="62.4" font-family="AlibabaPuHuiTi-Medium, Alibaba PuHuiTi" font-size="26"
                          font-weight="500">张三
                    </text>
                    <text x="30.5" y="89.6" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      职位头衔
                    </text>
                    <text x="30.5" y="131.8" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">188
                      6666 8888
                    </text>
                    <text x="30.5" y="151" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      ZhangSan@AiLogo.com
                    </text>
                    <text x="30.5" y="185.8" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      AILOGO科技有限公司
                    </text>
                    <text x="30.5" y="205.9" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      Ailogo.com
                    </text>
                    <text x="30.5" y="228.7" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      国泰民安万事顺利小区66弄
                    </text>
                  </svg>
                </div>
                <div class="list_top_li">
                  <svg id="svg2Back" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 283">


                    <!-- 背景矩形 -->
                    <rect style="fill: #f5f5f5" width="480" height="283"/>

                    <!-- 黑色多边形 -->
                    <polygon fill="#e2e2e2"
                             points="480 268.5 193.8 268.5 140.1 216.9 0 216.9 0 214.2 141.1 214.2 194.1 265.9 480 265.9 480 268.5"/>

                    <!-- 黑色路径 -->
                    <path fill="#e2e2e2"
                          d="M0,225.2v38l55.2-53.7c2.8-3.3,10-3.3,12.8,0l74.5,73.4h39.9l-113.7-112c-2.8-3.3-10-3.3-12.8,0L0,225.3h0Z"/>
                    <!-- 橙色路径 -->
                    <path :style="{ fill: cardBackground }"
                          d="M114.3,263c4.6-4,4.6-13.8,0-17.7L0,127.9v53.8s61,62.6,61,62.6c4.6,4,4.6,13.8,0,17.7l-20.7,21h54.2s19.8-20.1,19.8-20.1h0Z"/>

                    <!-- 底部橙色多边形 -->
                    <polygon :style="{ fill: cardBackground }"
                             points="480 279.1 152.8 279.1 148.9 283 480 283 480 280 480 279.1"/>
                    <image id="image_svg2Back" x="236" y="50" width="180" :height="calculateHeight('image_svg2Back')"  preserveAspectRatio="xMidYMid meet"
                           :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">商务名片板式二</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon">
                  <div class="title_icon_title font16"><img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载</div>
                  <div class="title_icon_down">
                    <div class="icon_down_list font14" @click="downloadZIP('svg2Front','svg2Back')"><img alt=""
                                                                                                         src="@a/ailogo/img2/png.svg"/>PNG高清文件下载
                    </div>

                    <div>
                      <!-- isSVG 为 false 时显示完整内容 -->
                      <div v-if="!isSVG" class="icon_down_list font14 svg">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                        <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="down_list_dd">
                          先在创作记录转矢量版
                          <img alt="" src="@a/ailogo/images/sv7on.svg"/>
                        </router-link>
                      </div>
                      <!-- isSVG 为 true 时显示简化内容 -->
                      <div v-else class="icon_down_list font14"
                           @click="downloadZIP('svg2Front','svg2Back',true)">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="svg3Front" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 283">

                    <!-- 背景矩形 -->
                    <rect fill="#fff" width="480" height="283"/>
                    <image id="image_svg3Front" x="20" y="10" width="80" :height="calculateHeight('image_svg3Front')"  preserveAspectRatio="xMidYMid meet"
                           :xlink:href="croppedImage"/>

                    <!-- 旋转的矩形组 -->
                    <rect :style="{ fill: cardBackground }" x="30.5" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-114.9 44.7) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="42.8" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-113.5 50.5) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="55" y="238.5" width="2.6" height="26.2" rx="1.3" ry="1.3"
                          transform="translate(-112 56.3) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="67.3" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-110.6 62.1) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="79.5" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-109.1 67.9) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="91.8" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-107.7 73.7) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="104" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-106.2 79.4) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="116.3" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-104.8 85.2) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="128.6" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-103.3 91) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="140.8" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-101.9 96.8) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="153.1" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-100.4 102.6) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="165.3" y="238.5" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(-99 108.3) rotate(-28.1)"/>

                    <!-- 水平矩形 -->
                    <rect :style="{ fill: cardBackground }" x="176.1" y="248.9" width="303.9" height="2.7"/>

                    <!-- 另一组旋转的矩形 -->
                    <rect :style="{ fill: cardBackground }" x="321.2" y="13.3" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(25.7 155.2) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="333.4" y="13.3" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(27.1 161) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="345.7" y="13.3" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(28.6 166.8) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="358" y="13.3" width="2.6" height="26.2" rx="1.3" ry="1.3"
                          transform="translate(30 172.6) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="370.2" y="13.3" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(31.5 178.4) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="382.5" y="13.3" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(32.9 184.1) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="394.7" y="13.3" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(34.4 189.9) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="407" y="13.3" width="2.6" height="26.2" rx="1.3" ry="1.3"
                          transform="translate(35.8 195.7) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="419.3" y="13.3" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(37.3 201.5) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="431.5" y="13.3" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(38.7 207.3) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="443.8" y="13.3" width="2.6" height="26.2" rx="1.3"
                          ry="1.3" transform="translate(40.2 213) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="456" y="13.3" width="2.6" height="26.2" rx="1.3" ry="1.3"
                          transform="translate(41.6 218.8) rotate(-28.1)"/>

                    <!-- 文字部分 -->
                    <text x="25" y="140.4" font-family="AlibabaPuHuiTi-Medium, Alibaba PuHuiTi" font-size="26"
                          font-weight="500">张三
                    </text>
                    <text x="25" y="167.6" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      职位头衔
                    </text>
                    <text x="265.6" y="127.2" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">188
                      6666 8888
                    </text>
                    <text x="265.6" y="146.4" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      ZhangSan@AiLogo.com
                    </text>
                    <text x="265.6" y="181.2" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      AILOGO科技有限公司
                    </text>
                    <text x="265.6" y="201.3" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      Ailogo.com
                    </text>
                    <text x="265.6" y="224.1" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      国泰民安万事顺利小区66弄
                    </text>
                  </svg>
                </div>
                <div class="list_top_li">
                  <svg id="svg3Back" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 283">
                    <!-- 背景矩形 -->
                    <rect style="fill: #f5f5f5" width="480" height="283"/>

                    <!-- 第一组旋转矩形 -->
                    <rect :style="{ fill: cardBackground }" x="30.5" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-112.4 44.1) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="42.8" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-110.9 49.9) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="55" y="233.1" width="2.6" height="26.2" rx="1.3" ry="1.3"
                          transform="translate(-109.5 55.7) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="67.3" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-108 61.5) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="79.5" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-106.6 67.2) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="91.8" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-105.1 73) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="104" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-103.7 78.8) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="116.3" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-102.2 84.6) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="128.6" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-100.8 90.4) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="140.8" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-99.3 96.1) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="153.1" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-97.9 101.9) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="165.3" y="233.1" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(-96.4 107.7) rotate(-28.1)"/>
                    <rect :style="{ fill: cardBackground }" x="176.1" y="243.5" width="303.9" height="2.7"/>

                    <!-- 第二组旋转矩形 -->
                    <rect :style="{ fill: cardBackground }" x="446.9" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(826.7 278.2) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="434.6" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(803.6 272.4) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="422.4" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(780.5 266.6) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="410.1" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(757.5 260.8) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="397.8" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(734.4 255) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="385.6" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(711.3 249.2) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="373.3" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(688.2 243.5) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="361.1" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(665.2 237.7) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="348.8" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(642.1 231.9) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="336.5" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(619 226.1) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="324.3" y="22.4" width="2.6" height="26.2" rx="1.3"
                          ry="1.3"
                          transform="translate(596 220.3) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="312" y="22.4" width="2.6" height="26.2" rx="1.3" ry="1.3"
                          transform="translate(572.9 214.6) rotate(-151.9)"/>
                    <rect :style="{ fill: cardBackground }" x="0" y="32.8" width="303.9" height="2.7"
                          transform="translate(303.9 68.2) rotate(-180)"/>
                    <image id="image_svg3Back" x="170" y="60" width="160" :height="calculateHeight('image_svg3Back')"  preserveAspectRatio="xMidYMid meet"
                           :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">商务名片板式三</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon">
                  <div class="title_icon_title font16"><img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载</div>
                  <div class="title_icon_down">
                    <div class="icon_down_list font14" @click="downloadZIP('svg3Front','svg3Back')"><img alt=""
                                                                                                         src="@a/ailogo/img2/png.svg"/>PNG高清文件下载
                    </div>
                    <div>
                      <!-- isSVG 为 false 时显示完整内容 -->
                      <div v-if="!isSVG" class="icon_down_list font14 svg">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                        <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="down_list_dd">
                          先在创作记录转矢量版
                          <img alt="" src="@a/ailogo/images/sv7on.svg"/>
                        </router-link>
                      </div>
                      <!-- isSVG 为 true 时显示简化内容 -->
                      <div v-else class="icon_down_list font14"
                           @click="downloadZIP('svg3Front','svg3Back',true)">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="svg4Front" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 283">
                    <!-- 背景矩形 -->
                    <rect fill="#fff" width="480" height="283"/>
                    <image id="image_svg4Front" x="285" y="60" width="160" :height="calculateHeight('image_svg4Front')"  preserveAspectRatio="xMidYMid meet"
                           :xlink:href="croppedImage"/>
                    <!-- 文字部分 -->
                    <text x="52.1" y="62.4" font-family="AlibabaPuHuiTi-Medium, Alibaba PuHuiTi" font-size="26"
                          font-weight="500">张三
                    </text>
                    <text x="52.1" y="89.6" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      职位头衔
                    </text>
                    <text x="52.1" y="131.8" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">188
                      6666 8888
                    </text>
                    <text x="52.1" y="151" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      ZhangSan@AiLogo.com
                    </text>
                    <text x="52.1" y="185.8" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      AILOGO科技有限公司
                    </text>
                    <text x="52.1" y="205.9" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      Ailogo.com
                    </text>
                    <text x="52.1" y="228.7" font-family="AlibabaPuHuiTi-Regular, Alibaba PuHuiTi" font-size="14">
                      国泰民安万事顺利小区66弄
                    </text>
                  </svg>
                </div>
                <div class="list_top_li">
                  <svg id="svg4Back" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 283">
                    <!-- 红色矩形 -->
                    <rect style="fill: #f5f5f5" width="480" height="283"/>
                    <image id="image_svg4Back" x="145" y="50" width="180" :height="calculateHeight('image_svg4Back')"  preserveAspectRatio="xMidYMid meet"
                           :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">商务名片板式四</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon">
                  <div class="title_icon_title font16"><img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载</div>
                  <div class="title_icon_down">
                    <div class="icon_down_list font14" @click="downloadZIP('svg4Front','svg4Back')"><img alt=""
                                                                                                         src="@a/ailogo/img2/png.svg"/>PNG高清文件下载
                    </div>
                    <div>
                      <!-- isSVG 为 false 时显示完整内容 -->
                      <div v-if="!isSVG" class="icon_down_list font14 svg">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                        <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="down_list_dd">
                          先在创作记录转矢量版
                          <img alt="" src="@a/ailogo/images/sv7on.svg"/>
                        </router-link>
                      </div>
                      <!-- isSVG 为 true 时显示简化内容 -->
                      <div v-else class="icon_down_list font14"
                           @click="downloadZIP('svg4Front','svg4Back',true)">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--<div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/mp/9.jpg"/></div>
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/mp/10.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">商务名片板式一</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载
                </div>
              </div>
            </div>
             <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/mp/12.jpg"/></ >
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/mp/11.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">商务名片板式一</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {fabric} from "fabric";
import JSZip from 'jszip';
import {saveAs} from 'file-saver'

export default {
  props: {
    picturesAndTextsWithBackground: null,
    // canvas: null,
    independentPatternWithBackground: null,
    picturesAndTexts: null,
    independentPattern: null,
    svgBaseUrl: null,
    croppedImage: null,
    background: null,
    oriImage: null,
    title: null,
    isSVG: false,
    // canvasWidth: 1200,
    // canvasHeight: 900,
  },
  data() {
    return {
      cardBackground: null,
      cardBackground2: null,
      GenerateManagementWindowActive: false,
      originalWidth: null,
      originalHeight: null,
    }
  },
  watch: {
    oriImage(newVal) {
      if (newVal) {
        this.getTopColor(); // 确保 croppedImage 有值后再调用方法
      }
    },
  },
  mounted() {
    if (this.oriImage) {
      this.getTopColor()
    }
  },
  methods: {
    // 计算高度的方法
    calculateHeight(id) {
      if (!this.originalHeight) {
        const img = new Image();
        img.src = this.croppedImage; // 设置 Base64 图片
        img.onload = () => {
          // 图片加载完成后，获取原始宽高
          this.originalWidth = img.width;
          this.originalHeight = img.height;
        };
        img.onerror = () => {
          console.error('图片加载失败');
        };
      }
      // 通过 id 获取 DOM 元素
      const imageElement = document.getElementById(id);
      if (imageElement) {
        // 获取 width 属性值
        const width = imageElement.getAttribute('width');
        // 根据 width 和原始宽高比例计算高度
        return (width / this.originalWidth) * this.originalHeight;
      }
    },
    processImage(base64) {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = base64;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);

          // 获取像素数据
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
          const colorCounts = {};

          // 统计颜色频率
          for (let i = 0; i < imageData.length; i += 4) {
            const r = imageData[i];
            const g = imageData[i + 1];
            const b = imageData[i + 2];
            const a = imageData[i + 3];

            // 忽略透明像素
            if (a === 0) continue;

            // 过滤黑色和白色
            if (this.isBlackOrWhite(r, g, b)) continue;

            const color = `rgb(${r}, ${g}, ${b})`;
            colorCounts[color] = (colorCounts[color] || 0) + 1;
          }

          // 按频率排序并提取前五种颜色
          const sortedColors = Object.entries(colorCounts)
              .sort((a, b) => b[1] - a[1])
              .slice(0, 5)
              .map((item) => item[0]);

          resolve(sortedColors); // 返回颜色数据
        };
      });
    },

    async getTopColor() {
      if (!this.oriImage) {
        console.error('oriImage 为空');
        return;
      }

      const sortedColors = await this.processImage(this.oriImage); // 等待 processImage 完成

      const {r, g, b} = this.parseRGB(this.background);
      if (this.isBlackOrWhite(r, g, b)) {
        this.cardBackground = sortedColors[0];
        this.cardBackground2 = sortedColors[1];
      } else {
        this.cardBackground = this.background;
        this.cardBackground2 = sortedColors[0];
      }
    },
    // 判断颜色是否接近黑色或白色
    isBlackOrWhite(r, g, b) {
      const threshold = 30; // 阈值，可以根据需要调整
      const isBlack = r < threshold && g < threshold && b < threshold; // 接近黑色
      const isWhite = r > 255 - threshold && g > 255 - threshold && b > 255 - threshold; // 接近白色
      return isBlack || isWhite;
    },
    parseRGB(color) {
      // 使用正则表达式解析 rgb 字符串
      const regex = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
      const match = color.match(regex);

      if (!match) {
        throw new Error('Invalid color format. Expected format: rgb(r, g, b)');
      }

      // 提取并返回 r, g, b 的值
      const r = parseInt(match[1], 10);
      const g = parseInt(match[2], 10);
      const b = parseInt(match[3], 10);

      return {r, g, b};
    },
    async downloadAsSVG(svgId) {
      try {
        // 获取 SVG 元素
        const svgElement = document.getElementById(svgId);
        if (!svgElement) {
          console.error(`未找到 ID 为 ${svgId} 的 SVG 元素`);
          return null;
        }

        // 将 SVG 元素序列化为字符串
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svgElement);

        // 创建 Blob 对象
        const blob = new Blob([svgString], {type: 'image/svg+xml;charset=utf-8'});
        return blob;
      } catch (error) {
        console.error('生成 SVG 文件失败:', error);
        return null;
      }
    },
    async downloadAsPNG(svgId) {
      // 获取 SVG 元素
      const svgElement = document.getElementById(svgId);

      if (!svgElement) {
        console.error(`SVG 元素 ${svgId} 未找到`);
        return null;
      }

      // 将 SVG 转换为字符串
      const svgString = new XMLSerializer().serializeToString(svgElement);

      // 使用 fabric.js 创建一个新的 canvas
      const canvas = new fabric.Canvas(document.createElement('canvas'));

      // 使用 fabric.js 加载 SVG 数据
      return new Promise((resolve, reject) => {
        fabric.loadSVGFromString(svgString, (objects, options) => {
          const group = fabric.util.groupSVGElements(objects, options);

          // 将 SVG 添加到 canvas 中
          canvas.add(group);

          // 设定 canvas 尺寸与 SVG 相同
          canvas.setWidth(group.width);
          canvas.setHeight(group.height);

          // 使用 fabric.js 将 canvas 转换为 PNG 数据 URL
          const dataURL = canvas.toDataURL({format: 'png'});

          // 解析 dataURL 为 Blob
          const blob = this.dataURLtoBlob(dataURL);
          resolve(blob);
        });
      });
    },

    dataURLtoBlob(dataURL) {
      const arr = dataURL.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], {type: mime});
    },

    async downloadZIP(frontSvgId, backSvgId, isDownloadSVG = false) {
      try {

        let frontBlob;
        let backBlob;
        const zip = new JSZip();
        if (isDownloadSVG) {
          if (this.isSVG) {
            frontBlob = await this.downloadAsSVG(frontSvgId);
            backBlob = await this.downloadAsSVG(backSvgId);
            zip.file('正面.svg', frontBlob);
            zip.file('背面.svg', backBlob);
            zip.file("SVG矢量图片文件说明.txt", "注意！！！ 点击SVG文件后，浏览器直接打开SVG文件预览是正常操作！！！\n" +
                "\n" +
                "SVG 是将图像描述为形状、路径、文本和滤镜效果的矢量格式。生成的文件可以在网络、印刷甚至资源受限的手持设备上提供高质量的图形。\n" +
                "\n" +
                "使用Adobe Illustrator、Coral Draw、Sketch、Affinity Designer等软件可以查看和编辑svg文件，还能导出保存为svg或其他格式的文件。\n" +
                "\t\t\t\t\n" +
                "注，Adobe Photoshop不支持编辑svg文件，请更换矢量图设计软件。");
          } else {
            //   弹出支付页面
          }

        } else {
          frontBlob = await this.downloadAsPNG(frontSvgId);
          backBlob = await this.downloadAsPNG(backSvgId);
          zip.file('正面.png', frontBlob);
          zip.file('背面.png', backBlob);
        }
        if (!frontBlob || !backBlob) {
          console.error('生成 图片 失败');
          return;
        }


        // 创建 ZIP 文件


        // 生成 ZIP 文件并触发下载
        zip.generateAsync({type: 'blob'}).then((content) => {
          saveAs(content, `${this.title}.zip`); // 使用 this.title 作为 ZIP 文件名
        });
      } catch (error) {
        console.error('下载 ZIP 文件失败:', error);
      }
    },
  }
}
</script>


<style>
@import "GenerateManagement.css";
</style>
